import { useAuth } from 'react-auth0'
import { useRouteMatch } from 'react-router-dom'

export default function CustomLogin() {
  const { auth0Client } = useAuth()

  const match = useRouteMatch<{ slug: string }>()

  auth0Client.loginWithRedirect({
    authorizationParams: {
      login_hint: match?.params?.slug
    }
  })

  return null
}
